(() => {
  'use strict';

  const partnerInterests = new Set(['Partner or sponsor', 'Creator or media', 'Survival Technology']);

  const setStep = (form, nextStep) => {
    const steps = Array.from(form.querySelectorAll('[data-aos-step]'));
    const target = form.querySelector(`[data-aos-step="${nextStep}"]`);
    if (!target) return;
    steps.forEach((step) => {
      const active = step === target;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
    });
    form.querySelectorAll('[data-aos-progress-dot]').forEach((dot) => {
      const number = Number(dot.dataset.aosProgressDot);
      dot.classList.toggle('is-active', number === nextStep);
      dot.classList.toggle('is-complete', number < nextStep);
    });
    const status = form.querySelector('[data-aos-step-status]');
    const labels = { 1: 'Your email', 2: 'Your interests', 3: 'Permission and optional details' };
    if (status) status.textContent = `Step ${nextStep} of 3: ${labels[nextStep]}`;
    form.dataset.currentStep = String(nextStep);
    const focusTarget = target.querySelector('input:not([type="hidden"]), select, button');
    if (focusTarget) window.setTimeout(() => focusTarget.focus(), 20);
  };

  const validateStep = (step) => {
    const fields = Array.from(step.querySelectorAll('input, select, textarea')).filter((field) => !field.disabled);
    for (const field of fields) {
      if (!field.checkValidity()) {
        field.reportValidity();
        return false;
      }
    }
    return true;
  };

  document.querySelectorAll('form.aos-insider-form').forEach((form) => {
    form.dataset.currentStep = '1';
    const updateWebsite = () => {
      const interest = form.querySelector('[data-aos-interest]');
      const wrap = form.querySelector('[data-aos-website-wrap]');
      const input = wrap && wrap.querySelector('input');
      if (!interest || !wrap || !input) return;
      const show = partnerInterests.has(interest.value);
      wrap.hidden = !show;
      input.disabled = !show;
      if (!show) input.value = '';
    };
    form.querySelector('[data-aos-interest]')?.addEventListener('change', updateWebsite);
    form.querySelectorAll('[data-aos-next]').forEach((button) => button.addEventListener('click', () => {
      const current = Number(form.dataset.currentStep || '1');
      const step = form.querySelector(`[data-aos-step="${current}"]`);
      if (step && validateStep(step)) {
        updateWebsite();
        setStep(form, Math.min(3, current + 1));
      }
    }));
    form.querySelectorAll('[data-aos-back]').forEach((button) => button.addEventListener('click', () => {
      const current = Number(form.dataset.currentStep || '1');
      setStep(form, Math.max(1, current - 1));
    }));
  });

  document.querySelectorAll('[data-aos-insider-popup]').forEach((popup) => {
    const backdrop = popup.querySelector('[data-aos-popup-backdrop]');
    const dialog = popup.querySelector('[role="dialog"]');
    const openers = popup.querySelectorAll('[data-aos-popup-open]');
    const closeButton = popup.querySelector('[data-aos-popup-close]');
    if (!backdrop || !dialog) return;

    const storageKey = 'aos-insider-auto-prompt-at';
    const days = Number(popup.dataset.frequencyDays || '14');
    const delay = Number(popup.dataset.autoDelay || '30000');
    let restoreFocus = null;

    const markPrompted = () => {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) { /* storage may be disabled */ }
    };
    const open = (automatic = false) => {
      if (!backdrop.hidden) return;
      restoreFocus = document.activeElement;
      backdrop.hidden = false;
      document.documentElement.classList.add('aos-insider-dialog-open');
      if (automatic) markPrompted();
      window.setTimeout(() => dialog.focus(), 20);
    };
    const close = () => {
      backdrop.hidden = true;
      document.documentElement.classList.remove('aos-insider-dialog-open');
      markPrompted();
      if (restoreFocus && typeof restoreFocus.focus === 'function') restoreFocus.focus();
    };
    const getFocusable = () => Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((node) => !node.hidden && node.offsetParent !== null);

    openers.forEach((button) => button.addEventListener('click', () => open(false)));
    closeButton?.addEventListener('click', close);
    backdrop.addEventListener('click', (event) => { if (event.target === backdrop) close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    let lastPrompt = 0;
    try { lastPrompt = Number(localStorage.getItem(storageKey) || '0'); } catch (error) { /* storage may be disabled */ }
    const eligible = !lastPrompt || Date.now() - lastPrompt > days * 86400000;
    if (eligible && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setTimeout(() => {
        if (window.scrollY >= Math.min(500, document.documentElement.scrollHeight * 0.2) && !document.hidden) open(true);
      }, delay);
    }
    if (popup.querySelector('[data-aos-popup-success]')) open(false);
  });
})();
